import React, { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'
import { compareVersions } from 'compare-versions'
import styles from './branch.module.scss'

function Branch({
    branch,
    setReadme,
}: {
    branch: FolderObject
    setReadme: Dispatch<SetStateAction<ModuleObject | undefined>>
}) {
    const [collapsed, setCollapsed] = useState(false)
    if (branch.modules) {
        branch.modules = branch.modules.sort(
            (a, b) => compareVersions(a.version, b.version) * -1
        )
    }
    return (
        <>
            {branch.modules && branch.modules.length > 0 ? (
                <li
                    onClick={() => {
                        setReadme((branch.modules as ModuleObject[])[0])
                    }}
                    key={branch.name}
                    className={styles.treeLeaf}
                >
                    {branch.name}
                </li>
            ) : (
                <li
                    data-cy="branchLeaf"
                    onClick={() => setCollapsed(!collapsed)}
                    key={branch.name}
                >
                    <img src="/icons/arrow-black.png" alt=">" className={styles.arrow + ' ' + (!collapsed && styles.rotated)} />
                    {branch.name}
                </li>
            )}
            {branch.children.length > 0 && !collapsed && (
                <ul className={styles.branch}>
                    {branch.children.map((child, key) => (
                        <Branch
                            branch={child}
                            setReadme={setReadme}
                            key={key}
                        />
                    ))}
                </ul>
            )}
        </>
    )
}

export default Branch
